module.exports = __webpack_public_path__ + "img/stephane-bourez-alien-panther.5c61340.jpg";